export enum DisplayModeEnum {
	CONSULTATION, REPORT
}